export const teacherGuidesKey = 'teacherGuides';
export const studentGuidesKey = 'studentGuides';
export const defaultKey = 'default';
export const preApKey = 'preap';
export const apKey = 'ap';

export const baseClickHelp = 'https://apclassroom.clickhelp.co/articles';
const preapBaseClickHelp = 'https://collegeboard.clickhelp.co/articles';
const apTeacherGuide = `${baseClickHelp}/#!ap-classroom-user-guide-for-teachers-publication`;
const apAdminCoordGuide = `${baseClickHelp}/#!ap-classroom-user-guide-for-administrators-and-coordinators/`;
const apStudentGuide = `${baseClickHelp}/#!ap-classroom-user-guide-for-students`;
const preapStudentGuide = `${preapBaseClickHelp}/#!pre-ap-classroom-user-guide-for-students/pre-ap-classroom-user-guide-for-students`;

export const PDFS = {
  [teacherGuidesKey]: {
    preap: {
      admin: [],
      coordinator: [],
      teacher: [],
      default: [],
    },
    ap: {
      default: [
        {
          href: apTeacherGuide,
          title: 'AP Teacher Guide to AP Classroom',
          webLink: true,
        },
      ],
      coordinator: [
        {
          href: apAdminCoordGuide,
          title: 'AP Administrator and Coordinator Guide to AP Classroom',
          webLink: true,
        },
      ],
      admin: [
        {
          href: apAdminCoordGuide,
          title: 'AP Administrator and Coordinator Guide to AP Classroom',
          webLink: true,
        },
      ],
      calculus: [
        {
          href: 'Teacher_Guide_to_AP_Calculus_Resources.pdf',
          title: 'Teacher Guide to AP Calculus Resources',
        },
      ],
      world_history: [
        {
          href: 'Teacher_Guide_to_AP_World_History_Resources.pdf',
          title: 'Teacher Guide to AP World History Resources',
        },
      ],
    },
    behavioral: {
      path: '/teacher_guides/',
      default: [
        {
          href: 'Pilot_Guide_for_AP_Teachers_and_Administrators.pdf',
          title: 'Pilot Guide',
        },
        {
          href: 'Users_Guide_to_the_AP_Question_Bank.pdf',
          title: "User's Guide to the Question Bank",
        },
      ],
    },
  },
  [studentGuidesKey]: {
    preap: {
      admin: [],
      coordinator: [],
      teacher: [],
      default: [
        {
          href: preapStudentGuide,
          title: 'Pre-AP Classroom User Guide for Students',
          webLink: true,
          appendText: 'includes video supports',
        },
      ],
    },
    ap: {
      default: [
        {
          href: apStudentGuide,
          title: 'AP Student Guide to AP Classroom',
          webLink: true,
        },
      ],
    },
    behavioral: {
      path: '/student_guides/',
      default: [
        {
          href: 'AP_Pilot_Guide_for_AP_Students_and_Parents_EN.pdf',
          title: 'AP® Student and Parent Pilot Guide',
        },
        {
          href: 'Guia_del_programa_piloto_para_estudiantes_y_padres_de_AP_2017-18_final.pdf',
          title: 'Guía del programa piloto para estudiantes y padres de AP®',
        },
        {
          href: 'Student_Guide_to_the_AP_Question_Bank.pdf',
          title: 'Student Guide to the Question Bank',
        },
      ],
    },
  },
};

export const APCLASSROOM_FOLDER = `apclassroom`;
